import type { IFuseOptions } from 'fuse.js'
import {
  type FuzzySearchResult,
  useFuzzySearch,
} from '@/components/admin/shared/hooks/use-fuzzy-search'
import type { SystemDesignProblem } from './use-system-design-problems'

export const SYSTEM_DESIGN_SEARCH_KEYS: NonNullable<
  IFuseOptions<SystemDesignProblem>['keys']
> = [
  { name: 'title', weight: 0.35 },
  { name: 'allSources.title', weight: 0.25 },
  { name: 'allSources.source', weight: 0.1 },
  { name: 'companyTags.name', weight: 0.1 },
  { name: 'topics', weight: 0.1 },
  { name: 'description', weight: 0.1 },
]

export type SystemDesignSearchResult = FuzzySearchResult<SystemDesignProblem>

export function useSystemDesignSearch(problems: SystemDesignProblem[]) {
  return useFuzzySearch(problems, SYSTEM_DESIGN_SEARCH_KEYS)
}
